const DEFAULT_LENGTH = 6
const PAD_CHAR = '0'

export default class KeyGenerator {

    constructor(prefix) {
        this.prefix = prefix
    }

    getRandom(length = DEFAULT_LENGTH) {
        let value = Math.random().toString(36).substr(2, length)
        if (value.length < length) {
            value += PAD_CHAR.repeat(length - value.length)
        }
        return this.wrapId(value)
    }

    getNext() {
        if (this.counter) {
            return this.wrapId(++(this.counter))
        }
        this.counter = 1
        return this.wrapId(this.counter)
    }

    // Private

    wrapId(id) {
        if (this.prefix) {
            return this.prefix + id
        }
        return id
    }
}
